var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBed = function SvgBed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58.528,
    height: 55.319
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#e4dcd3",
    d: "m2.94 44.353.57 7.462h53.45l.419-7.462-7.089-28.446V8.384a3.23 3.23 0 0 0-3.207-3.207H13.357a3.207 3.207 0 0 0-3.147 3.207v7.4Zm14.8-22.931h8.887a2.536 2.536 0 0 0 2.452-2.557v-1.908h1.677v1.907a2.536 2.536 0 0 0 2.536 2.515h8.887a2.536 2.536 0 0 0 2.62-2.515v-1.907h3.605l6.581 26.45H5.35l6.666-26.45h3.186v1.907a2.536 2.536 0 0 0 2.536 2.557Zm-.44-2.557v-6.016a.44.44 0 0 1 .44-.44h8.887a.44.44 0 0 1 .44.44v6.016a.44.44 0 0 1-.44.419h-8.889a.42.42 0 0 1-.44-.419Zm15.637 0v-6.016a.44.44 0 0 1 .44-.44h8.887a.44.44 0 0 1 .44.44v6.016a.42.42 0 0 1-.44.419h-8.889a.42.42 0 0 1-.44-.419ZM5.434 49.719l-.314-4.193h50.1l-.252 4.192Zm7.923-42.362h33.789a1.11 1.11 0 0 1 1.111 1.111v6.393h-3.458v-2.1a2.536 2.536 0 0 0-2.536-2.536h-8.888a2.536 2.536 0 0 0-2.536 2.536v2.1h-1.761v-2.1a2.536 2.536 0 0 0-2.536-2.536h-8.8a2.536 2.536 0 0 0-2.536 2.536v2.1H12.31V8.384a1.09 1.09 0 0 1 1.047-1.027",
    "data-name": "Path 9"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h58.528v55.319H0z",
    "data-name": "Rectangle 42"
  })))));
};
export default SvgBed;